import {
    Component,
    enableProdMode,
    Inject,
    Injectable,
    OnDestroy,
    OnInit,
    ViewChild,
    ViewContainerRef
} from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationError, NavigationStart, Route, Router } from '@angular/router';
import { Observable, of, Subscription, concat } from 'rxjs';
import { delay, filter, map } from 'rxjs/operators';
import { LoadingService } from './common/layout/loading.service';
import { AppInitializerService } from './core/services/app-initializer.service';
import { isNullOrUndefined } from 'util';
import { UserService } from './core/services/user.service';
import { Title } from '@angular/platform-browser';
import { APP_CONFIG, AppConfig } from './core/app-config/app-config.module';
import { NotificationService } from './common/layout/notification.service';
import { DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { AuthService } from './views/auth/auth.service';
import { LayoutService } from './common/layout/layout.service';

const prodMode = window['external_configuration']['prodMode'];

if (prodMode) {
    enableProdMode();
}

@Component({
    selector: 'ns-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
    private subscriptions: Subscription = new Subscription();
    private prevUrl;

    private dialogRef: DialogRef;
    @ViewChild("container", { read: ViewContainerRef })
    public containerRef: ViewContainerRef;

    public mobileManagerAuthCheckUrl: string = null;

    constructor(
        private appInitializerService: AppInitializerService,
        public loadingService: LoadingService,
        private router: Router,
        private userService: UserService,
        private authService: AuthService,
        private titleService: Title,
        private activatedRoute: ActivatedRoute,
        private notificationService: NotificationService,
        private dialogService: DialogService,
        public layoutService: LayoutService,
        @Inject(APP_CONFIG) private config: AppConfig
    ) {
        this.manageLoading();
    }

    ngOnInit(): void {
    }

    private manageLoading() {
        this.subscriptions.add(
            this.router.events
                .pipe(
                    filter(event => {
                        return event instanceof NavigationEnd || event instanceof NavigationError;
                    })
                )
                .pipe(
                    map(() => {
                        const supportsNativeSmoothScroll = 'scrollBehavior' in document.documentElement.style;
                        if (supportsNativeSmoothScroll) {
                            window.scrollTo(0, 0);
                        }
                        const contentContainer = document.body.querySelector('.content');
                        if (contentContainer) {
                            contentContainer.scrollTop = 0;
                        }
                        this.setTitle(this.getPageTitle(this.activatedRoute));
                        this.loadingService.stop();
                    })
                )
                .subscribe()
        );

        this.subscriptions.add(
            this.router.events
                .pipe(
                    filter(event => {
                        return event instanceof NavigationStart;
                    })
                )
                .pipe(
                    map(() => {

                        this.manageMobileCheck();

                        this.loadingService.start();
                    })
                )
                .subscribe()
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    public setTitle(newTitle: string) {
        this.titleService.setTitle(newTitle);
    }

    public getPageTitle(route: ActivatedRoute): string {
        let currentRoute = route;
        while (!isNullOrUndefined(currentRoute.firstChild)) {
            currentRoute = currentRoute.firstChild;
            const routeConfig: Route = currentRoute.routeConfig;
            const data = isNullOrUndefined(routeConfig.data) ? [] : routeConfig.data;

            if (isNullOrUndefined(data['pageTitle']) && isNullOrUndefined(data['breadCrumbTitle'])) {
                continue;
            }
        }
        let pageTitle = this.config.appName;
        if (currentRoute.snapshot.data['pageTitle']) {
            pageTitle += ' - ' + currentRoute.snapshot.data['pageTitle'];
        }
        return pageTitle;
    }

    public onMobileAppsClick(event) {
        window.open(this.mobileManagerAuthCheckUrl, '_blank');
        event.preventDefault();
    }

    public manageMobileCheck() {
        if (this.userService.user) {
            this.mobileManagerAuthCheckUrl = this.userService.user.goldfingerConfiguration.mobileManagerAuthCheckUrl;
        }
    }

}
